import React, { Fragment } from 'react'
import { FormInput, FormSubmit, FormWrapper } from '@myxplor/forms'
import withRemoteRequest from '../../remote-request'
import { withRouter } from 'react-router-dom'

const apiEndPoint = (serviceId) => `${process.env.REACT_APP_API_HOST}/api/iss_credentials/${serviceId}`

const defaultOnSubmit = ({ remote_request, updateServiceId }) => payload => {
  remote_request.submit(apiEndPoint(payload.service_id), {
    method: 'GET',
    jsonAPI: true
  })
  updateServiceId(payload.service_id)
}


export const GetISSCreds = ({
  formOptions = {},
  name = 'get_iss_creds',
  remote_request,
  onSubmit = defaultOnSubmit,
  updateExistingCreds,
  updateServiceId
}) => {
  const { loading, success, data } = remote_request.state

  if (success) {
    // Set upstream state to response data
    updateExistingCreds(data)
  }

  const errors = remote_request.state.errors
  return (
    <Fragment>
      <FormWrapper
        {...formOptions}
        onSubmit={onSubmit({ remote_request, name, updateServiceId })}
        render={formProps => (
          <fieldset>
            <FormInput
              label="Input Service ID"
              name="service_id"
              value={formProps.values.service_id}
              required
              onChange={formProps.onChange}
              errors={Object.keys(errors).length !== 0 ? errors[0] : null}
              loading={loading}
              autoFocus
            />

            <FormSubmit
              loading={loading}
              disabled={!formProps.valid}
              loadingTitle="Finding credentials..."
            >
              Find existing credentials
            </FormSubmit>
          </fieldset>
        )}
      />
    </Fragment>
  )
}

export default withRouter(withRemoteRequest(GetISSCreds))


// WEBPACK FOOTER //
// ./src/iss-credentials-update/forms/getISSCreds.js